import { queryClient } from '@/common/contexts/react-query/ReactQueryProvider';
import { MENHIR_ENDPOINTS } from '@/common/integrations/menhir/menhir.endpoints';
import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
} from '@tanstack/react-query';
import {
  activateMealSinglePayment,
  getMealConfiguration,
} from './meal.service';
import { TMealConfiguration } from './meal.types';

export function useGetMealConfiguration(
  options?: UseQueryOptions<TMealConfiguration>
) {
  const { data: mealConfiguration, ...rest } = useQuery({
    queryKey: [MENHIR_ENDPOINTS.EMPLOYEE.MEAL.CONFIG.ROOT],
    queryFn: getMealConfiguration,
    ...options,
  });

  return {
    mealConfiguration,
    ...rest,
  };
}

export function useActivateMealSinglePayment(
  options?: UseMutationOptions<void, unknown, string>
) {
  return useMutation({
    mutationFn: activateMealSinglePayment,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [MENHIR_ENDPOINTS.EMPLOYEE.MEAL.CONFIG.ROOT],
      });
    },
    ...options,
  });
}
